import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { RoutesPrivate } from './private'
import { RoutesPublic, RoutesPublicView } from './public'

export const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<RoutesPrivate />} />

        <Route path="/auth/*" element={<RoutesPublic />} />

        <Route path="/view/*" element={<RoutesPublicView />} />
      </Routes>
    </BrowserRouter>
  )
}
